export default __webpack_public_path__ + "static/media/kangaroo.c75d5341.svg";